import React, { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { LOGO_ICON_URL } from "../lib/branding";

const links = [
  { label: "Start", href: "#home" },
  { label: "Leistungen", href: "#leistungen" },
  { label: "Über uns", href: "#ueber-uns" },
  { label: "Angebote", href: "#angebote" },
  { label: "Rezensionen", href: "#rezensionen" },
  { label: "FAQ", href: "#faq" },
  { label: "Kontakt", href: "#kontakt" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-black/85 backdrop-blur-xl border-b border-zinc-800"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      {/* Top ticker */}
      <div className="hidden md:block gold-bg text-black overflow-hidden">
        <div className="flex whitespace-nowrap ticker-track text-[11px] tracking-[0.3em] uppercase font-semibold py-1">
          {Array.from({ length: 2 }).map((_, i) => (
            <div key={i} className="flex items-center">
              {[
                "Familienbetrieb seit Generationen",
                "TÜV & HU vor Ort",
                "Meisterwerkstatt in Neuss",
                "4,7 / 5 bei Google · 119 Rezensionen",
                "Ehrliche Preise · Schnelle Termine",
              ].map((t, k) => (
                <span key={k} className="px-6 flex items-center gap-6">
                  <span>{t}</span>
                  <span className="opacity-40">◆</span>
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>

      <nav className="max-w-7xl mx-auto px-5 md:px-6 lg:px-8 h-16 md:h-20 flex items-center justify-between gap-4">
        <a
          href="#home"
          data-testid="navbar-logo"
          className="flex items-center gap-3 group shrink-0"
        >
          <span className="w-14 h-14 md:w-16 md:h-16 shrink-0 inline-block logo-blend">
            <img
              src={LOGO_ICON_URL}
              alt="Autohaus Barwinski Logo"
              className="w-full h-full object-cover"
            />
          </span>
          <div className="leading-tight hidden sm:block">
            <div className="font-display text-xs md:text-sm tracking-tight uppercase whitespace-nowrap">
              Autohaus Barwinski
            </div>
            <div className="text-[9px] md:text-[10px] text-zinc-400 tracking-[0.15em] uppercase whitespace-nowrap">
              by Spitzer und Demirci GmbH
            </div>
          </div>
        </a>

        <ul className="hidden lg:flex items-center gap-5 xl:gap-7">
          {links.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                data-testid={`nav-link-${l.href.replace("#", "")}`}
                className="text-[12px] xl:text-sm uppercase tracking-widest text-zinc-300 hover:gold-text transition-colors whitespace-nowrap"
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-4 shrink-0">
          <a
            href="tel:02131544154"
            data-testid="navbar-call-btn"
            className="hidden xl:inline-flex items-center gap-2 text-sm tracking-[0.05em] text-zinc-300 hover:gold-text transition-colors whitespace-nowrap"
          >
            <Phone size={16} className="shrink-0" />
            <span>02131 544154</span>
          </a>
          <a
            href="#termin"
            data-testid="navbar-appointment-btn"
            className="hidden sm:inline-flex items-center gold-bg text-black font-semibold text-[12px] xl:text-sm px-3.5 xl:px-4 py-2 xl:py-2.5 tracking-widest uppercase transition-colors whitespace-nowrap"
          >
            Termin anfragen
          </a>
          <button
            data-testid="mobile-menu-toggle"
            className="lg:hidden text-white p-2"
            onClick={() => setOpen((v) => !v)}
            aria-label="Menü"
          >
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </nav>

      {open && (
        <div className="lg:hidden border-t border-zinc-800 bg-black">
          <ul className="px-5 py-4 flex flex-col gap-3">
            {links.map((l) => (
              <li key={l.href}>
                <a
                  onClick={() => setOpen(false)}
                  href={l.href}
                  data-testid={`mobile-nav-link-${l.href.replace("#", "")}`}
                  className="block py-2 text-sm uppercase tracking-widest text-zinc-200 hover:gold-text"
                >
                  {l.label}
                </a>
              </li>
            ))}
            <a
              onClick={() => setOpen(false)}
              href="#termin"
              data-testid="mobile-appointment-btn"
              className="mt-2 inline-flex justify-center items-center gold-bg text-black font-semibold text-sm px-4 py-3 tracking-widest uppercase"
            >
              Termin anfragen
            </a>
          </ul>
        </div>
      )}
    </header>
  );
}
